import {FilterOperator, IczTableDataSource} from '@icz/angular-table';
import {EntityType} from '|api/commons';
import {CirculationSearchService, ExtendedCirculationActivityDto} from '|shared';

const CIRCULATION_ENTITY_TYPE_FIELD_NAME = 'circulationEntityType';

export class FileDetailActivitiesDatasource extends IczTableDataSource<ExtendedCirculationActivityDto> {

  constructor(
    searchService: CirculationSearchService,
    fileId: number,
  ) {
    super(
      searchParams => {
        const hasCirculationEntityTypeFilter = searchParams.filter.find(f => f.fieldName === CIRCULATION_ENTITY_TYPE_FIELD_NAME);

        if (!hasCirculationEntityTypeFilter) {
          searchParams.filter.push(
            {
              fieldName: CIRCULATION_ENTITY_TYPE_FIELD_NAME,
              operator: FilterOperator.equals,
              value: EntityType.FILE,
            },
          );
        }

        return searchService.findActivitiesForFile(searchParams, fileId);
      },
    );
  }

}
